if (!customElements.get('ksl-arrival')) {
  customElements.define('ksl-arrival', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.scene = this.querySelector('.ksl-arrival__scene');
      this.reveals = [...this.querySelectorAll('[data-arrival-reveal]')];
      const host = this.closest('.shopify-section');
      this.header = this.dataset.home === 'true' && this.dataset.headerMotion === 'true' && host === document.querySelector('#MainContent .shopify-section') ? document.querySelector('.section-header') : null;
      this.configure = () => {
        this.observer?.disconnect();
        this.reveals.forEach((el) => el.classList.remove('is-arrival-pending'));
        this.enabled = this.dataset.motion === 'true' && this.dataset.editor !== 'true' && document.body.hasAttribute('data-ksl-motion') && !this.preference.matches && !window.Shopify?.designMode;
        this.classList.toggle('is-arrival-motion', this.enabled);
        this.header?.classList.toggle('ksl-arrival-nav', this.enabled);
        if (this.enabled && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.remove('is-arrival-pending'); this.observer.unobserve(entry.target); } });
          }, { threshold: .08, rootMargin: '0px 0px -20px 0px' });
          this.reveals.forEach((el) => { if (el.getBoundingClientRect().top >= innerHeight - 20) { el.classList.add('is-arrival-pending'); this.observer.observe(el); } });
        }
        this.measure();
        this.update();
      };
      this.measure = () => {
        const top = this.getBoundingClientRect().top + scrollY;
        this.headerOffset = Math.min(top, innerHeight * .35);
        this.style.setProperty('--arrival-header-height', `${this.headerOffset}px`);
      };
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(true); }); };
      addEventListener('scroll', this.schedule, { passive: true, signal });
      addEventListener('resize', () => { this.measure(); this.schedule(); }, { passive: true, signal });
      this.preference.addEventListener('change', this.configure, { signal });
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.ksl-arrival__scroll');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        if (target) { event.preventDefault(); target.scrollIntoView({ behavior: this.enabled ? 'smooth' : 'auto', block: 'start' }); }
      }, { signal });
      this.configure();
    }
    update(smooth = false) {
      const bounds = this.getBoundingClientRect();
      this.classList.toggle('is-arrival-in-view', this.enabled && bounds.bottom > 0 && bounds.top < innerHeight);
      const target = this.enabled ? Math.max(0, Math.min(1, (this.headerOffset - bounds.top) / ((this.scene?.offsetHeight || this.offsetHeight || 1) * .7))) : 0;
      const now = performance.now();
      const elapsed = Math.min(64, now - (this.lastFrameTime ?? now - 16));
      this.lastFrameTime = now;
      const blend = 1 - Math.exp(-elapsed / 100);
      this.progress = smooth && this.enabled ? (this.progress ?? target) + (target - (this.progress ?? target)) * blend : target;
      if (Math.abs(target - this.progress) < .0008) this.progress = target;
      this.style.setProperty('--arrival-progress', this.progress.toFixed(4));
      this.header?.style.setProperty('--arrival-progress', this.progress.toFixed(4));
      if (this.progress !== target) this.schedule();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.header?.classList.remove('ksl-arrival-nav');
      this.header?.style.removeProperty('--arrival-progress');
      this.reveals?.forEach((el) => el.classList.remove('is-arrival-pending'));
      this.classList.remove('is-arrival-motion');
      this.classList.remove('is-arrival-in-view');
      this.style.removeProperty('--arrival-progress');
    }
  });
}
